export const modalsTariSalud = {
  es: {
    urls: [
     

      // Nuevas Preproduccion 

      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/calcular/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/recuperarpresupuesto/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena/es",
      "https://webpublicapre.segurcaixaadeslas.es/salud/adeslas_dental_max/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_total/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_plus/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_vital/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_total/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_seniors/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_go/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_extra_150/es",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_max/es",


      //URLS nuevas del excel
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/recuperarpresupuesto/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/salud/adeslas_dental_max/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_dental_total/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_plus/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_vital/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_total/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_seniors/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_go/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_extra_150/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/",

      // Producción
      "https://www.segurcaixaadeslas.es/contratacion/salud/calcular/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/recuperarpresupuesto/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_max/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_total/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_plus/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_vital/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_total/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_seniors/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_go/es",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_extra_150/es",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.prod.az.internal/",
    ],
    modalIndex: 23,
  },
  cat: {
    urls: [

      //Nuevas Urls Pre Web publica (ca)

      "https://webpublicapre.segurcaixaadeslas.es/contractacio/salut/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/recuperarpresupuesto/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_max/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_total/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_plus/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_vital/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_total/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_seniors/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_go/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_extra_150/ca",
      "https://webpublicapre.segurcaixaadeslas.es/contractacio/salut/adeslas_dental_max/ca",


      //URLS nuevas del excel
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contractacio/salut/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/recuperarpresupuesto/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_dental_max/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_dental_total/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_plus/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_vital/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_total/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_seniors/ca",
      " https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_go/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/contratacion/salud/adeslas_plena_extra_150/ca",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/",

   
      // PRO Buenas esta redireccionado 
      "https://www.segurcaixaadeslas.es/contratacion/salud/calcular/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/recuperarpresupuesto/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_max/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_total/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_plus/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_vital/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_total/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_seniors/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_go/cat",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_extra_150/cat",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.prod.az.internal/",

    ],
    modalIndex: 24,
  },
  en: {
    urls: [

      //Urls Pre 
      "http/quote/health/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/en",
      "https://webpublicapre.segurcaixaadeslas.es/contratacion/salud/calcular/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_go/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_plena_total/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_seniors/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_plena_vital/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_plena/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_plena_plus/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_plena_extra_150/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/retrieveestimate/en",
      "https://webpublicapre.segurcaixaadeslas.es/quote/health/adeslas_dental_max/en",



      //URLS nuevas del excel
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_dental_max/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_go/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_plena_total/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_seniors/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_plena_vital/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_plena/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_plena_plus/en",
      " https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_plena_extra_150/en",
      " https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/retrieveestimate/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/quote/health/adeslas_dental_total/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.preprod.az.internal/",



      // PRO redireccionadas 
      "https://www.segurcaixaadeslas.es/contratacion/salud/calcular/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/recuperarpresupuesto/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_max/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_dental_total/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_plus/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_vital/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_total/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_seniors/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_go/en",
      "https://www.segurcaixaadeslas.es/contratacion/salud/adeslas_plena_extra_150/en",
      "https://webpublica-cms-actualizada-frontend-webpublica.apps.prod.az.internal/",

      
    ],
    modalIndex: 25,
  },
};
